import { Persistence, StateRepository } from '@angular-ru/ngxs/decorators';
import { NgxsDataRepository } from '@angular-ru/ngxs/repositories';
import { Injectable } from '@angular/core';
import { ActivatedRoute, NavigationEnd, NavigationStart, Params, Router } from '@angular/router';
import { State, Store } from '@ngxs/store';
import { from } from 'rxjs';

import { IMatchResult, INavigationHandlerStateModel, INavigationSubscriber } from './navigation-handler.state.models';

@Persistence({
    existingEngine: sessionStorage
})
@StateRepository()
@State<INavigationHandlerStateModel>({
    name: 'navigationHandlerState',
    defaults: {
    }
})
@Injectable()
export class NavigationHandlerService extends NgxsDataRepository<INavigationHandlerStateModel>{

    static queryParamsSelector(state: INavigationHandlerStateModel) {
        return state.queryParams;
    }

    subscribers: INavigationSubscriber[] = [];

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private store: Store
    ) {
        super();
        this.initialize();
    }

    addSubscriber(subscriber: INavigationSubscriber) {
        this.subscribers.push(subscriber);
    }

    deleteSubscriber(subscriber: INavigationSubscriber) {
        const index = this.subscribers.findIndex(item => item.id === subscriber.id);
        this.subscribers.splice(index, 1);
    }


    initialize() {

        this.router.events.subscribe(async event => {
            if (event instanceof NavigationStart) {
                return;
            } else if (event instanceof NavigationEnd) {
                await this.processListener();
            }
        });
    }

    async processListener() {
        for (const subscriber of this.subscribers) {
            subscriber.isAsync
                ? from(subscriber.navigationCommandFunc(subscriber, this.route)).subscribe()
                : await subscriber.navigationCommandFunc(subscriber, this.route)
        }
    }







}
